import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=2dc2d84a&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=2dc2d84a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2d84a",
  null
  
)

export default component.exports